import { render, staticRenderFns } from "./Crisis_warning.vue?vue&type=template&id=4f419d2a"
import script from "./Crisis_warning.vue?vue&type=script&lang=js"
export * from "./Crisis_warning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports